import { render, staticRenderFns } from "./ContractsModal.vue?vue&type=template&id=c3635108&scoped=true"
import script from "./ContractsModal.vue?vue&type=script&lang=js"
export * from "./ContractsModal.vue?vue&type=script&lang=js"
import style0 from "./ContractsModal.vue?vue&type=style&index=0&id=c3635108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3635108",
  null
  
)

export default component.exports